@import './normalize.less';

// 旧版规范
// @import './theme.dark.base.less';
// @import './theme.light.base.less';
// // 2022.12.14号 新版规范
// @import './theme.dark.less';
// @import './theme.light.less';
// // 新版设计室规范
// @import './theme.new.dark.less';
// @import './theme.new.light.less';

@import './theme-dark.less';
@import './theme-light.less';
@import './theme-xdesign.less';

:root {
    // 字号
    --font-size-xs: 12px;
    --font-size-sm: 14px;
    --font-size-md: 16px;
    --font-size-lg: 18px;
    --font-size-xl: 20px;

    // 行号
    --line-height-xs: 16px;
    --line-height-sm: 20px;
    --line-height-md: 22px;
    --line-height-lg: 24px;
    --line-height-xl: 26px;

    // 间距
    --gap-xs: 4px;
    --gap-sm: 8px;
    --gap-md: 12px;
    --gap-lg: 16px;
    --gap-xl: 20px;
}
